import { useState, useEffect, useCallback, useRef, useMemo } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { FaPlane, FaExclamationTriangle, FaTimes } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { debounce } from "lodash";
import flighthome from "../assets/flighthome.jpg";
import About from "./About";
import Features from "./Features";
import Price from "./Price";
import SpecialOffer from "./SpecialOffer";
import Services from "./Services";
import Testimonials from "./Testimonials";
import Faq from "./Faq";
import { useSelector, useDispatch } from "react-redux";
import { checkUserLogin } from "../redux/reduxThunk/thunkAuthUser/AuthUser";
import PaymentModal from "./PaymentModal";
import LoginModal from "./LoginModal";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../context/AuthContext";

// Components
import SearchForm from "./FlightSearch/SearchForm";
import FlightResults from "./FlightResults/FlightResults";
import PriceModal from "./Modals/PriceModal";
import PassengerForm from "./PassengerForm/PassengerForm";
import BookingSuccessModal from "./Modals/BookingSuccessModal";
import FeedbackModal from "./Modals/FeedbackModal";
import UpdateStorageModal from "./Modals/UpdateStorageModal";
import { FiRefreshCw } from "react-icons/fi";
// import axios from "axios";

const Homepage2 = () => {
  const { authdata } = useSelector((state) => state.auth);
  console.log(authdata);

  const [checkModelLogin, setCheckModelLogin] = useState(false);

  const isLoggedIn = Boolean(authdata && authdata.token);
  console.log(isLoggedIn);

  const {
    setOpenModel,
    setWaiting,
    waiting,
    setAddBothOnwardAndReturn,
    setReturnRefId,
    addBothOnwardAndReturn,
    returnRefId,
    onwardRefID,
    setOnwardRefID,
    setUser,
  } = useAuth();

  const [userWallet, setUserWallet] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const url = import.meta.env.VITE_URL;

  useEffect(() => {
    // Homepage2.jsx में:
    const fetchUserWallet = async () => {
      try {
        // ✅ User के लिए सही endpoint
        const response = await axios.get(`${API_BASE}/api/wallet/my-balance`, {
          withCredentials: true,
        });

        console.log("Wallet API Response:", response.data);

        if (response.data.success) {
          const walletData = response.data.data;

          // Check if wallet exists
          if (walletData && walletData.length > 0) {
            const wallet = walletData[0];
            setUserWallet({
              status: "active", // ये confirm करें कि wallet active है
              balance: wallet.total || 0,
              walletId: wallet._id,
              isActive: true,
            });
          } else {
            // No wallet found - wallet not activated
            setUserWallet({
              status: "not_activated",
              balance: 0,
              isActive: false,
            });
          }
        } else {
          // API success false
          setUserWallet({
            status: "error",
            balance: 0,
            isActive: false,
            message: response.data.message || "Failed to load wallet",
          });
        }
      } catch (error) {
        console.error("Error fetching wallet:", error);
        setUserWallet({
          status: "error",
          balance: 0,
          isActive: false,
          message: "Failed to load wallet information",
        });
      }
    };

    fetchUserWallet();
  }, [url, isLoggedIn, checkModelLogin]);

  const ref = useRef(1);

  const [onwardData, setOnwardData] = useState([]);
  const [returnData, setReturnData] = useState([]);

  const API_BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2;

  const [airports, setAirports] = useState([]);

  const [filteredFromAirports, setFilteredFromAirports] = useState([]);
  const [filteredToAirports, setFilteredToAirports] = useState([]);

  // Add loading states for airport search
  const [isLoadingFromAirports, setIsLoadingFromAirports] = useState(false);
  const [isLoadingToAirports, setIsLoadingToAirports] = useState(false);

  // ✅ Validation Setup
  const today = new Date();
  const sixtyDaysAgo = new Date(today);
  sixtyDaysAgo.setDate(today.getDate() - 60);
  const twelveYearsAgo = new Date(today);
  twelveYearsAgo.setFullYear(today.getFullYear() - 12);

  const formSchema = z.object({
    mobile: z
      .string()
      .min(1, "Mobile number is required")
      .regex(/^[6-9]\d{9}$/, "Enter a valid 10-digit Indian mobile number"),
    email: z
      .string()
      .min(1, "Email is required")
      .regex(/^[a-zA-Z0-9._%+-]+@gmail\.com$/, "Only Gmail addresses allowed"),
    passengers: z
      .array(
        z.object({
          title: z.string().min(1, "Title required"),
          gender: z.string().min(1, "Gender required"),
          fName: z
            .string()
            .min(1, "First name required")
            .regex(/^[A-Za-z\s]+$/, "Only alphabets allowed"),
          lName: z
            .string()
            .min(1, "Last name required")
            .regex(/^[A-Za-z\s]+$/, "Only alphabets allowed"),
          dob: z
            .string()
            .min(1, "Date of Birth is required")
            .refine((value) => {
              if (!value) return false;
              const dobDate = new Date(value);
              return !isNaN(dobDate.getTime());
            }, "Enter valid DOB"),
          ppNo: z.string().optional(),
          ppIss: z.string().optional(),
          ppExp: z.string().optional(),
          ppNat: z.string().optional(),
        })
      )
      .min(1, "At least one passenger required"),
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    reValidateMode: "onBlur",
  });

  // API Configuration
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [tripType, setTripType] = useState(0);
  const [statusRefdId, setStatusRefdId] = useState(null);
  const [statusDatas, setStatusDatas] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  void motion;

  const [formData, setFormData] = useState({
    class: "Economy",
    from: "",
    to: "",
    departure: "",
    returnDate: "",
    tripType: tripType,
    adults: 1,
    children: 0,
    infants: 0,
    serType: 1,
    cabin: "E",
    fareType: "A",
  });

  const [dropdowns, setDropdowns] = useState({
    class: false,
    from: false,
    to: false,
    travellers: false,
    service: false,
    fare: false,
  });

  // API Integration States
  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState({
    onward: [],
    return: [],
  });
  const [combinedResults, setCombinedResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const pagedResults = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return combinedResults.slice(start, start + pageSize);
  }, [combinedResults, currentPage]);

  const totalPages = useMemo(
    () => Math.ceil(combinedResults.length / pageSize) || 1,
    [combinedResults.length]
  );

  const [error, setError] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [debugInfo, setDebugInfo] = useState("");
  const [isBooking, setIsBooking] = useState(false);
  const [isPaying, setIsPaying] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [pendingFareForAuth, setPendingFareForAuth] = useState(null);
  const [amount, setAmount] = useState(null);
  const totalPayableAmount = useMemo(() => {
    return Number(amount || 0);
  }, [amount]);

  const [bookingError, setBookingError] = useState(null);
  const [bookingResult, setBookingResult] = useState(null);
  const [lastSearchPayload, setLastSearchPayload] = useState(null);

  // Price verification modal states
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [selectedFlightForPrice, setSelectedFlightForPrice] = useState(null);
  const [priceOptions, setPriceOptions] = useState([]);
  const [isLoadingPrices, setIsLoadingPrices] = useState(false);
  const [selectedFare, setSelectedFare] = useState(null);
  const [validationRequirements, setValidationRequirements] = useState({
    doc_mandatory: 0,
    pan_mandatory: 0,
    document_type: 0,
  });
  const [showPassengerForm, setShowPassengerForm] = useState(false);
  const [passengerDetails, setPassengerDetails] = useState([]);
  const [formPassengerData, setFormPassengerData] = useState([
    {
      title: "",
      fName: "",
      lName: "",
      pType: "",
      gender: "",
      dob: "",
      ppNo: "",
      ppIss: "",
      ppExp: "",
      ppNat: "",
    },
  ]);
  const [contactInfo, setContactInfo] = useState({
    mobile: "",
    email: "",
  });
  const [ssrOptions, setSsrOptions] = useState({});
  const [selectedSsr, setSelectedSsr] = useState({});
  const [isLoadingSsr, setIsLoadingSsr] = useState(false);
  const [expandedFlights, setExpandedFlights] = useState({});
  const [availableSeats, setAvailableSeats] = useState([]);
  const [isLoadingSeats, setIsLoadingSeats] = useState(false);
  const [selectedSeats, setSelectedSeats] = useState({});
  const [showBookingSuccess, setShowBookingSuccess] = useState(false);
  const [bookingSuccessData, setBookingSuccessData] = useState(null);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedbackText, setFeedbackText] = useState("");
  const [isSubmittingFeedback, setIsSubmittingFeedback] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  // Sorting and filtering states
  const [sortBy, setSortBy] = useState("cheapest");
  const [filterStops, setFilterStops] = useState("all");

  // Seat Selection Visibility
  const [showSeatSelection, setShowSeatSelection] = useState(false);

  ///////////////////// btn disable
  const [isWalletProcessing, setIsWalletProcessing] = useState(false);

  // Mark unused variables to satisfy linter
  void setSelectedFlight;
  void setPassengerDetails;
  void ssrOptions;
  void isLoadingSsr;

  // Dropdown Data States - Now using airports from database
  const [isLoadingLocations, setIsLoadingLocations] = useState(false);

  // Pre-filter airports by service type for better performance
  const airportsByServiceType = useMemo(() => {
    if (airports.length === 0) return { domestic: [], international: [] };

    const domestic = airports.filter((airport) => airport.country === "India");
    const international = airports.filter(
      (airport) => airport.country !== "India"
    );

    return { domestic, international };
  }, [airports]);

  // ✅ Debounced search functions
  const debouncedSearchFromAirports = useCallback(
    debounce(async (searchTerm) => {
      if (!searchTerm || searchTerm.trim().length < 2) {
        setFilteredFromAirports([]);
        setIsLoadingFromAirports(false);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          from: false,
        }));
        return;
      }

      try {
        setIsLoadingFromAirports(true);
        const response = await axios.get(
          `${API_BASE}/api/debouce/search?q=${encodeURIComponent(searchTerm)}`
        );

        // Transform the API response to match your expected format
        const transformedAirports = response.data.map((airport) => ({
          code: airport.airportcode,
          name: airport.airportname,
          city: airport.airportcity,
          country: airport.airportcountry,
          airport: airport.airportname,
        }));

        setFilteredFromAirports(transformedAirports);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          from: transformedAirports.length > 0,
        }));
      } catch (error) {
        console.error("Error searching from airports:", error);
        setFilteredFromAirports([]);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          from: false,
        }));
      } finally {
        setIsLoadingFromAirports(false);
      }
    }, 300), // 300ms debounce delay
    [API_BASE]
  );

  const debouncedSearchToAirports = useCallback(
    debounce(async (searchTerm) => {
      if (!searchTerm || searchTerm.trim().length < 2) {
        setFilteredToAirports([]);
        setIsLoadingToAirports(false);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          to: false,
        }));
        return;
      }

      try {
        setIsLoadingToAirports(true);
        const response = await axios.get(
          `${API_BASE}/api/debouce/search?q=${encodeURIComponent(searchTerm)}`
        );

        // Transform the API response to match your expected format
        const transformedAirports = response.data.map((airport) => ({
          code: airport.airportcode,
          name: airport.airportname,
          city: airport.airportcity,
          country: airport.airportcountry,
          airport: airport.airportname,
        }));

        setFilteredToAirports(transformedAirports);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          to: transformedAirports.length > 0,
        }));
      } catch (error) {
        console.error("Error searching to airports:", error);
        setFilteredToAirports([]);
        setDropdowns((prevDropdowns) => ({
          ...prevDropdowns,
          to: false,
        }));
      } finally {
        setIsLoadingToAirports(false);
      }
    }, 300), // 300ms debounce delay
    [API_BASE]
  );

  // ✅ Improved From input change handler with debounce
  const handleFromInputChange = (e) => {
    const value = e.target.value;

    setFormData((prev) => ({
      ...prev,
      from: value,
    }));

    // Clear previous results if search term is too short
    if (!value || value.trim().length < 2) {
      setFilteredFromAirports([]);
      setDropdowns((prevDropdowns) => ({
        ...prevDropdowns,
        from: false,
      }));
      return;
    }

    // Show loading state
    setIsLoadingFromAirports(true);
    setDropdowns((prevDropdowns) => ({
      ...prevDropdowns,
      from: true,
    }));

    // Trigger debounced search
    debouncedSearchFromAirports(value);
  };

  // ✅ Improved To input change handler with debounce
  const handleToInputChange = (e) => {
    const value = e.target.value;

    setFormData((prev) => ({
      ...prev,
      to: value,
    }));

    // Clear previous results if search term is too short
    if (!value || value.trim().length < 2) {
      setFilteredToAirports([]);
      setDropdowns((prevDropdowns) => ({
        ...prevDropdowns,
        to: false,
      }));
      return;
    }

    // Show loading state
    setIsLoadingToAirports(true);
    setDropdowns((prevDropdowns) => ({
      ...prevDropdowns,
      to: true,
    }));

    // Trigger debounced search
    debouncedSearchToAirports(value);
  };

  // Cleanup debounce functions on unmount
  useEffect(() => {
    return () => {
      debouncedSearchFromAirports.cancel();
      debouncedSearchToAirports.cancel();
    };
  }, [debouncedSearchFromAirports, debouncedSearchToAirports]);

  // Load locations on component mount
  useEffect(() => {
    fetchLocations();
  }, []);

  useEffect(() => {
    dispatch(checkUserLogin());
  }, [dispatch]);

  // Check if stored date/time has been reached and show update modal
  useEffect(() => {
    const checkUpdateDate = () => {
      const storedDate = localStorage.getItem("flightSearchUpdateDate");
      if (storedDate) {
        const updateDate = new Date(storedDate);
        const now = new Date();

        if (now >= updateDate) {
          setShowUpdateModal(true);
        }
      }
    };

    checkUpdateDate();
    const interval = setInterval(checkUpdateDate, 60000);
    return () => clearInterval(interval);
  }, []);

  // Log debug info in development
  useEffect(() => {
    if (
      typeof import.meta !== "undefined" &&
      import.meta.env?.MODE === "development" &&
      debugInfo
    ) {
      console.debug("Flight debug:", debugInfo);
    }
  }, [debugInfo]);

  // Root refs for all dropdowns
  const travellersRef = useRef(null);
  const fromRef = useRef(null);
  const toRef = useRef(null);
  const serviceRef = useRef(null);
  const fareRef = useRef(null);

  // Dropdown/outside click logic for all dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdowns.travellers &&
        travellersRef.current &&
        !travellersRef.current.contains(event.target)
      ) {
        setDropdowns((prev) => ({ ...prev, travellers: false }));
      }
      if (
        dropdowns.from &&
        fromRef.current &&
        !fromRef.current.contains(event.target)
      ) {
        setDropdowns((prev) => ({ ...prev, from: false }));
      }
      if (
        dropdowns.to &&
        toRef.current &&
        !toRef.current.contains(event.target)
      ) {
        setDropdowns((prev) => ({ ...prev, to: false }));
      }
      if (
        dropdowns.service &&
        serviceRef.current &&
        !serviceRef.current.contains(event.target)
      ) {
        setDropdowns((prev) => ({ ...prev, service: false }));
      }
      if (
        dropdowns.fare &&
        fareRef.current &&
        !fareRef.current.contains(event.target)
      ) {
        setDropdowns((prev) => ({ ...prev, fare: false }));
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdowns]);

  // Add this useEffect to properly merge data
  useEffect(() => {
    if (onwardData.length > 0 && returnData.length > 0) {
      // Make sure both are arrays before merging
      const onwardArray = Array.isArray(onwardData) ? onwardData : [onwardData];
      const returnArray = Array.isArray(returnData) ? returnData : [returnData];

      setAddBothOnwardAndReturn([...onwardArray, ...returnArray]);
    }
  }, [onwardData, returnData]); // This runs whenever onwardData or returnData changes

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRefresh = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/removecookies`, {
        withCredentials: true, // because cookies
      });

      if (res.data.success === true) {
        // Clear localStorage
        localStorage.clear();

        // Optional: reload page
        window.location.reload();
      }
    } catch (error) {
      console.error("Error removing cookies", error);
    }
  };

  const fetchLocations = async () => {
    try {
      setIsLoadingLocations(true);
      // Initial airports load if needed
      const response = await fetch(`${API_BASE}/api/airport`, {
        credentials: "include",
      });
      const data = await response.json();
      if (data.success && data.data) {
        const mappedAirports = data.data.map((airport) => ({
          code: airport.airportcode || airport.code,
          name: airport.airportname || airport.name,
          city: airport.airportcity || airport.city,
          country: airport.airportcountry || airport.country,
          airport: airport.airportname || airport.name,
        }));
        setAirports(mappedAirports);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setError("Failed to load locations");
    } finally {
      setIsLoadingLocations(false);
    }
  };

  // Get token from localStorage
  const getTokenFromLocalStorage = () => {
    try {
      const tokenData = localStorage.getItem("flightToken");
      if (!tokenData) {
        setDebugInfo("No token found in localStorage");
        return null;
      }
      return tokenData || null;
    } catch (error) {
      console.error("Error reading token from localStorage:", error);
      setDebugInfo(`LocalStorage token error: ${error.message}`);
      return null;
    }
  };

  // Get flightID, refID and full status from localStorage
  const getFlightDataFromStorage = () => {
    try {
      const flightStatus = localStorage.getItem("flightStatus");
      if (flightStatus) {
        const status = JSON.parse(flightStatus);
        return {
          flightID: status.flightID,
          refID: status.refID,
          status: status,
        };
      }
    } catch (error) {
      console.error("Error parsing flight status from localStorage:", error);
    }
    return {
      flightID: null,
      refID: null,
      status: null,
    };
  };

  const searchFlights = async (searchData) => {
    try {
      setWaiting(true);
      setDebugInfo("Starting flight search...");

      // 1) CHECK TOKEN
      const checkToken = await fetch(`${API_BASE}/api/flight/checkToken`, {
        method: "GET",
        credentials: "include",
      });

      const checkResult = await checkToken.json();

      if (!checkResult.success) {
        setDebugInfo("Token missing → generating new token...");

        // GENERATE TOKEN
        const genToken = await fetch(`${API_BASE}/api/getToken`, {
          method: "GET",
          credentials: "include",
        });

        const tokenResult = await genToken.json();

        if (!tokenResult.success) {
          // Provide more detailed error message
          const errorMessage = tokenResult.message || "Failed to generate flight token";
          const errorDetails = tokenResult.debug ? `\nDetails: ${JSON.stringify(tokenResult.debug, null, 2)}` : "";
          const missingVars = tokenResult.missing ? `\nMissing env vars: ${tokenResult.missing.join(", ")}` : "";
          
          console.error("Token generation failed:", {
            message: errorMessage,
            details: tokenResult.debug,
            missing: tokenResult.missing,
            fullResponse: tokenResult,
          });
          
          throw new Error(`${errorMessage}${missingVars}${errorDetails}`);
        }

        setDebugInfo("New token generated successfully");
      } else {
        setDebugInfo("Token verified successfully");
      }

      // 3) CALL SEARCH API
      setDebugInfo("Calling search API...");

      const response = await fetch(`${API_BASE}/api/postSearchFlight`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(searchData),
      });

      if (!response.ok) {
        const errorMsg = await response.text();
        throw new Error(`Search API failed: ${errorMsg}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "Search failed");
      }

      // V2 API Response Structure
      const responseData = data.data;
      
      // DEBUG: Log the full response structure to understand what we're getting
      console.log("🔍 Full API Response Structure:", JSON.stringify(responseData, null, 2));
      console.log("🔍 Response keys:", Object.keys(responseData || {}));
      console.log("🔍 responseData.flights exists:", !!responseData?.flights);
      console.log("🔍 responseData.flights length:", responseData?.flights?.length);
      console.log("🔍 responseData.Results exists:", !!responseData?.Results);
      console.log("🔍 responseData.Results length:", responseData?.Results?.length);
      console.log("🔍 responseData.results exists:", !!responseData?.results);
      console.log("🔍 responseData.results length:", responseData?.results?.length);
      console.log("🔍 responseData.data exists:", !!responseData?.data);
      if (responseData?.data) {
        console.log("🔍 responseData.data keys:", Object.keys(responseData.data));
        console.log("🔍 responseData.data.flights exists:", !!responseData.data.flights);
        console.log("🔍 responseData.data.flights length:", responseData.data.flights?.length);
      }
      
      // Check for V2 error response
      if (responseData?.code === "error") {
        throw new Error(responseData.error_msg || "Flight search failed");
      }

      // V2: Extract flights from response - check multiple possible locations
      // V2 structure can be: data.flights, data.Results, data.results, or data.data.flights
      let flights = [];
      
      if (responseData?.flights && Array.isArray(responseData.flights)) {
        flights = responseData.flights;
        console.log("✅ Found flights in responseData.flights:", flights.length);
      } else if (responseData?.Results && Array.isArray(responseData.Results)) {
        flights = responseData.Results;
        console.log("✅ Found flights in responseData.Results:", flights.length);
      } else if (responseData?.results && Array.isArray(responseData.results)) {
        flights = responseData.results;
        console.log("✅ Found flights in responseData.results:", flights.length);
      } else if (responseData?.data?.flights && Array.isArray(responseData.data.flights)) {
        flights = responseData.data.flights;
        console.log("✅ Found flights in responseData.data.flights:", flights.length);
      } else if (responseData?.data?.Results && Array.isArray(responseData.data.Results)) {
        flights = responseData.data.Results;
        console.log("✅ Found flights in responseData.data.Results:", flights.length);
      } else if (responseData?.data?.results && Array.isArray(responseData.data.results)) {
        flights = responseData.data.results;
        console.log("✅ Found flights in responseData.data.results:", flights.length);
      } else {
        // Try to find any array in the response
        console.warn("⚠️ No flights array found in expected locations. Searching entire response...");
        const searchForFlights = (obj, depth = 0) => {
          if (depth > 3) return null; // Limit recursion
          if (Array.isArray(obj) && obj.length > 0) {
            // Check if it looks like a flights array
            if (obj[0]?.flightID || obj[0]?.Flights || obj[0]?.Fare) {
              return obj;
            }
          }
          if (typeof obj === 'object' && obj !== null) {
            for (const key in obj) {
              const result = searchForFlights(obj[key], depth + 1);
              if (result) return result;
            }
          }
          return null;
        };
        const foundFlights = searchForFlights(responseData);
        if (foundFlights) {
          flights = foundFlights;
          console.log("✅ Found flights by searching response:", flights.length);
        } else {
          console.error("❌ Could not find flights array in response");
        }
      }
      
      const refID = responseData?.status?.refID || responseData?.Status?.refID || responseData?.data?.status?.refID || responseData?.data?.Status?.refID;

      if (flights.length === 0) {
        alert("No flights available for the selected criteria.");
        setDebugInfo("No flights found");
        return { ...responseData, results: [], flights: [] };
      }

      // V2: Process flights to normalize structure
      const processedFlights = flights.map((flight) => {
        // V2: flightID is now string, not integer
        // V2: Enhanced fare information
        const fare = flight.Fare || flight.fare || {};
        
        return {
          ...flight,
          flightID: String(flight.flightID || flight.flightId || ""), // V2: String
          Fare: {
            ...fare,
            // V2: New fare fields
            fareTypeInd: fare.fareTypeInd,
            fareTypeDesc: fare.fareTypeDesc,
            popMsg: fare.popMsg,
            refundType: fare.refundType,
            validation: fare.validation || {},
            // V2: Enhanced baggage info
            bagCkin: fare.bagCkin || flight.bagCkin,
            bagCbin: fare.bagCbin || flight.bagCbin,
            // V2: Return object for round trips
            Return: fare.Return,
          },
          // V2: Terminal information
          depTer: flight.depTer,
          arrTer: flight.arrTer,
          // V2: Operating airline
          airCodeOp: flight.airCodeOp,
          airNameOp: flight.airNameOp,
        };
      });

      if (searchData?.serType === 1) {
        if (ref.current === 1) {
          setOnwardData({ ...data, data: { ...responseData, flights: processedFlights } });
          setOnwardRefID(refID || "");
          ref.current = 2;
        } else if (ref.current === 2) {
          setReturnData({ ...data, data: { ...responseData, flights: processedFlights } });
          setReturnRefId(refID || "");
        }
      }

      setDebugInfo("Flight search success");
      setStatusDatas(refID);
      setOpenModel(true);

      // Return normalized response
      return {
        ...responseData,
        Status: { refID },
        status: { refID },
        results: processedFlights,
        flights: processedFlights,
        Results: processedFlights,
      };
    } catch (error) {
      console.error("Search Flights Error:", error.message);
      setDebugInfo(error.message);
      throw error;
    } finally {
      setWaiting(false);
    }
  };

  // V2: Fetch all fare types for a flight (NEW endpoint)
  const fetchFareDetails = async (flightId, refId) => {
    try {
      const response = await fetch(`${API_BASE}/api/postFareDetails`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          flightID: flightId,
          refID: refId,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        console.warn("Fare details fetch failed, using search results:", data.message);
        return null; // Fallback to search results
      }

      // V2: postFareDetails returns { results: [...], Status: {...} }
      // Each result in results array is a different fare type
      return data.data; // Returns all fare types for the flight
    } catch (error) {
      console.error("Error fetching fare details:", error);
      return null; // Fallback to search results
    }
  };

  // V2: Fetch SSR options and validation for a selected fare
  // According to V2 docs: postPriceVerify is called to:
  // 1. Verify the price (might have fare difference from postFareDetails)
  // 2. Get SSR options (baggage & meals)
  // 3. Get validation requirements
  const fetchSSROptions = async (flightId, refId, isRoundTrip = false) => {
    try {
      console.log("🔍 Step 2: Calling postPriceVerify for flightID:", flightId, "refID:", refId);
      const response = await fetch(`${API_BASE}/api/postPriceVerify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          flightID: flightId,
          refID: refId,
          isRoundTrip: isRoundTrip,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        console.warn("⚠️ Price verify failed:", data.message);
        return {
          ssrInfo: {},
          validationRequirements: {
            doc_mandatory: 0,
            pan_mandatory: 0,
            document_type: 0,
          },
          priceDifference: 0,
          verifiedPrice: null,
        };
      }

      const priceResponse = data.data;
      console.log("🔍 Price Verify Response:", JSON.stringify(priceResponse, null, 2));
      
      // V2: Extract price difference (fareDiff) if available
      const fareDiff = priceResponse?.result?.Fare?.total?.fareDiff || 
                       priceResponse?.Fare?.total?.fareDiff || 0;
      const verifiedPrice = priceResponse?.result?.Fare?.total?.total || 
                           priceResponse?.Fare?.total?.total || null;
      
      console.log("💰 Price Check - Fare Difference:", fareDiff);
      console.log("💰 Price Check - Verified Price:", verifiedPrice);
      
      const validationRequirements = {
        doc_mandatory: priceResponse?.doc_mandatory || priceResponse?.result?.Validation?.doc_mandatory || 0,
        pan_mandatory: priceResponse?.pan_mandatory || priceResponse?.result?.Validation?.pan_mandatory || 0,
        document_type: priceResponse?.document_type || priceResponse?.result?.Validation?.document_type || 0,
      };

      const result = priceResponse?.result || priceResponse?.Flights || priceResponse;
      const ssrInfo = result?.ssrInfo || result?.Ssrinfo || 
                      priceResponse?.ssrInfo || priceResponse?.Ssrinfo || 
                      priceResponse?.result?.ssrInfo || priceResponse?.result?.Ssrinfo || {};
      
      console.log("🔍 SSR Info from postPriceVerify:", ssrInfo);
      console.log("🔍 SSR Onward.Bagg:", ssrInfo?.Onward?.Bagg || ssrInfo?.Onward?.bagg || []);
      console.log("🔍 SSR Onward.Meal:", ssrInfo?.Onward?.Meal || ssrInfo?.Onward?.meal || []);

      return {
        ssrInfo,
        validationRequirements,
        priceDifference: parseInt(fareDiff || 0), // V2: Fare difference from postFareDetails
        verifiedPrice: verifiedPrice ? parseInt(verifiedPrice) : null, // V2: Verified price from postPriceVerify
        remarks: priceResponse?.remarks || priceResponse?.result?.Validation?.remarks,
        genRemarks: priceResponse?.genRemarks || priceResponse?.result?.Validation?.genRemarks,
        fNameFormat: priceResponse?.fName || priceResponse?.result?.Validation?.fName,
        lNameFormat: priceResponse?.lName || priceResponse?.result?.Validation?.lName,
      };
    } catch (error) {
      console.error("❌ Error fetching SSR options:", error);
      return {
        ssrInfo: {},
        validationRequirements: {
          doc_mandatory: 0,
          pan_mandatory: 0,
          document_type: 0,
        },
        priceDifference: 0,
        verifiedPrice: null,
      };
    }
  };

  // Price Verification API - V2 Enhanced
  // V2 Flow: Get all fare types from postFareDetails (SSR will be fetched separately when user selects a fare)
  const verifyFlightPrice = async (flightId, refId, isRoundTrip = false) => {
    try {
      setIsLoadingPrices(true);

      // STEP 1: Get ALL fare types using postFareDetails (V2)
      // According to V2 docs: postFareDetails returns all fare types for display
      // SSR options will be fetched separately via fetchSSROptions when user selects a fare
      console.log("🔍 Step 1: Fetching all fare types from postFareDetails...");
      const fareDetailsData = await fetchFareDetails(flightId, refId);
      
      let fareOptions = [];
      
      if (fareDetailsData && fareDetailsData.results && Array.isArray(fareDetailsData.results) && fareDetailsData.results.length > 0) {
        // V2: postFareDetails returns multiple fare types in results array
        console.log("✅ Got fare details - fare types:", fareDetailsData.results.length);
        console.log("🔍 Fare Details Response:", JSON.stringify(fareDetailsData, null, 2));
        
        // V2: Get refID from Status node in fareDetailsData
        const fareDetailsRefID = fareDetailsData?.Status?.refID || refId;
        
        // V2: ONLY use actual fare types from postFareDetails - DO NOT create fake fare options from SSR
        fareOptions = fareDetailsData.results.map((fareResult, index) => {
          const fare = fareResult.Fare || {};
          const flights = fareResult.Flights || {};
          const validation = fareResult.Validation || {};
          
          // V2: Get flightID from the first segment of Onward flight
          // Each fare type has its own flightID in the Onward segment
          const onwardSegments = flights?.Onward || [];
          const firstSegment = onwardSegments?.[0] || {};
          const fareSpecificFlightID = firstSegment?.flightID || flightId;
          
          // Parse baggage strings (remove || separator)
          const bagCkin = (fare.bagCkin || flights.bagCkin || "").replace(/\|\|/g, "").trim();
          const bagCbin = (fare.bagCbin || flights.bagCbin || "").replace(/\|\|/g, "").trim();
          
          return {
            fareName: fare.fareTypeDesc || `Fare ${index + 1}`,
            price: parseInt(fare.total?.total || 0),
            base: parseInt(fare.total?.base || 0),
            tax: parseInt(fare.total?.tax || 0),
            netfare: parseInt(fare.total?.netfare || 0),
            bagCkin: bagCkin,
            bagCbin: bagCbin,
            seats: fare.seats || "N/A",
            fareTypeInd: fare.fareTypeInd,
            fareTypeDesc: fare.fareTypeDesc,
            popMsg: fare.popMsg,
            refundType: fare.refundType || "P",
            refundable: fare.refundType === "P" ? "Partially Refundable" : "Non-Refundable",
            cancelChgAir: fare.cancelChgAir,
            cancelChgFTD: fare.cancelChgFTD,
            baggage: {
              cabin: bagCbin,
              checkin: bagCkin,
            },
            validation: validation,
            flightData: fareResult,
            // V2: Use fare-specific flightID and refID from fareDetails response
            flightID: fareSpecificFlightID, // Each fare has its own flightID
            refID: fareDetailsRefID, // refID from Status node in postFareDetails response
            isFromFareDetails: true,
            index: index,
            // SSR will be fetched separately when user selects this fare
            ssrInfo: null,
            baggageOptions: [],
            mealOptions: [],
          };
        });
      } else {
        // Fallback: If postFareDetails fails, try postPriceVerify to get at least one fare
        console.warn("⚠️ postFareDetails failed, trying postPriceVerify as fallback...");
        const ssrData = await fetchSSROptions(flightId, refId, isRoundTrip);
        const result = ssrData?.result || {};
        const fare = result?.Fare || {};
        const flights = result?.Flights || result;
        
        if (fare.total) {
          const bagCkin = (fare.bagCkin || flights?.bagCkin || "").replace(/\|\|/g, "").trim();
          const bagCbin = (fare.bagCbin || flights?.bagCbin || "").replace(/\|\|/g, "").trim();
          
          fareOptions.push({
            fareName: fare.fareTypeDesc || "Standard Fare",
            price: parseInt(fare.total.total || 0),
            base: parseInt(fare.total.base || 0),
            tax: parseInt(fare.total.tax || 0),
            netfare: parseInt(fare.total.netfare || 0),
            bagCkin: bagCkin,
            bagCbin: bagCbin,
            seats: fare.seats || flights?.seats || "N/A",
            fareTypeInd: fare.fareTypeInd,
            fareTypeDesc: fare.fareTypeDesc,
            popMsg: fare.popMsg,
            refundType: fare.refundType || flights?.refundable || "P",
            refundable: (fare.refundType || flights?.refundable || "P") === "P" ? "Partially Refundable" : "Non-Refundable",
            cancelChgAir: fare.cancelChgAir,
            cancelChgFTD: fare.cancelChgFTD,
            baggage: {
              cabin: bagCbin,
              checkin: bagCkin,
            },
            validation: result?.Validation || {},
            flightID: flightId,
            refID: refId,
            ssrInfo: ssrData.ssrInfo,
            baggageOptions: ssrData.ssrInfo?.Onward?.Bagg || ssrData.ssrInfo?.Onward?.bagg || [],
            mealOptions: ssrData.ssrInfo?.Onward?.Meal || ssrData.ssrInfo?.Onward?.meal || [],
            priceCheckData: ssrData.validationRequirements,
            doc_mandatory: ssrData.validationRequirements.doc_mandatory,
            pan_mandatory: ssrData.validationRequirements.pan_mandatory,
            document_type: ssrData.validationRequirements.document_type,
            remarks: ssrData.remarks,
            genRemarks: ssrData.genRemarks,
            fNameFormat: ssrData.fNameFormat,
            lNameFormat: ssrData.lNameFormat,
          });
        }
      }

      // Ensure we always return at least one fare option
      if (fareOptions.length === 0) {
        console.error("❌ No fare options available. Creating default fare option.");
        fareOptions.push({
          fareName: "Standard Fare",
          price: 0,
          base: 0,
          tax: 0,
          bagCkin: "",
          bagCbin: "",
          seats: "N/A",
          refundable: "Partially Refundable",
          baggage: {
            cabin: "",
            checkin: "",
          },
          flightID: flightId,
          refID: refId,
          ssrInfo: null,
          baggageOptions: [],
          mealOptions: [],
        });
      }
      
      console.log("✅ Total fare types from postFareDetails:", fareOptions.length);
      console.log("✅ Fare types breakdown:", fareOptions.map(f => ({
        name: f.fareName,
        fareTypeInd: f.fareTypeInd,
        fareTypeDesc: f.fareTypeDesc,
        price: f.price,
      })));
      
      // V2: CRITICAL - Only return actual fare types from postFareDetails
      // DO NOT create fake fare options from SSR options
      // SSR options should be shown as add-ons AFTER user selects a fare, not as separate fare options
      if (fareOptions.length === 0) {
        console.error("❌ ERROR: No fare options from postFareDetails!");
      } else {
        console.log("✅ V2: Returning ONLY actual fare types from postFareDetails. SSR options will be fetched separately when user selects a fare.");
      }

      // Store fare options (without SSR - SSR will be fetched when user selects a fare)
      setPriceOptions(fareOptions);
      
      // Set default validation requirements (will be updated when SSR is fetched)
      setValidationRequirements({
        doc_mandatory: 0,
        pan_mandatory: 0,
        document_type: 0,
      });

      return fareOptions;
    } catch (error) {
      console.error("Price verification error:", error);
      setError(error.message);
      setPriceOptions([]);
      throw error;
    } finally {
      setIsLoadingPrices(false);
    }
  };

  // Seat Selection API
  const selectSeats = async (flightId, refId) => {
    try {
      setIsLoadingSsr(true);

      const response = await fetch(`${API_BASE}/api/selectSeats`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          flightID: flightId,
          refID: refId,
        }),
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || "Seat selection failed");
      }

      setSsrOptions(data.data || {});
      return data.data;
    } catch (error) {
      console.error("Seat selection error:", error);
      setError(error.message);
      throw error;
    } finally {
      setIsLoadingSsr(false);
    }
  };

  // Generate simplified passenger details for seat selection
  const generateSeatPassengerDetails = () => {
    const totalpassenger =
      formData.adults + formData.children + formData.infants;
    const passenger = [];

    // If no passenger are configured, return at least one default passenger
    if (totalpassenger === 0) {
      return [
        {
          title: "Mr",
          fName: "Test",
          lName: "User",
          pType: "A",
        },
      ];
    }

    for (let i = 0; i < totalpassenger; i++) {
      const passengerData = formPassengerData[i] || {};
      const passengerType =
        i < formData.adults
          ? "A"
          : i < formData.adults + formData.children
          ? "C"
          : "I";

      passenger.push({
        title: passengerData.title || "Mr",
        fName: passengerData.firstName || "Test",
        lName: passengerData.lastName || "User",
        pType: passengerType,
      });
    }

    return passenger;
  };

  // Fetch available seats
  const fetchSeats = async (flightId, refId) => {
    try {
      setIsLoadingSeats(true);

      // Generate simplified passenger details for seat selection
      const passengerDetails = generateSeatPassengerDetails();

      const response = await fetch(`${API_BASE}/api/seats`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          flightID: Number(flightId),
          refID: refId,
          passenger: passengerDetails,
        }),
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || "Seat fetching failed");
      }

      // Extract seat map from the API response
      const seatMap = data.data?.FlightSeat?.Onward?.[0]?.SeatMap || [];

      setAvailableSeats(seatMap);
      return seatMap;
    } catch (error) {
      console.error("Error fetching seats:", error);
      setAvailableSeats([]);
      throw error;
    } finally {
      setIsLoadingSeats(false);
    }
  };

  void selectSeats;

  // Booking with SSR API
  const bookFlightWithSSR = async (
    flight,
    passenger,
    searchPayload,
    dataforWallet,
    amount
  ) => {
    try {
      setIsBooking(true);
      setBookingError(null);
      setBookingResult(null);

      const clientId = generateClientID();

      const passengerData = generatePassengerDetails();

      const reqBody = {
        ...searchPayload,
        selected: flight,
        returnRefId: statusDatas,
        clientID: clientId,
        selectedSeats: selectedSeats,
        passenger: passengerData,
        mobile: contactInfo.mobile,
        email: contactInfo.email,
        flightID: flight?.Flights?.Onward[0]?.flightID,
        serType: formData.serType,
        tripType: tripType,
        isRoundTrip: flight.isRoundTrip || false,
        onwardRefID: onwardRefID,
        onwardFlight: flight.onwardFlight || null,
        returnFlight: flight.returnFlight || null,
        totalAmount: flight.totalPrice || flight?.Fare?.total?.total,
      };

      const res = await fetch(`${API_BASE}/api/checkAuth`, {
        credentials: "include",
      });
      const dataAuth = await res.json();

      if (!dataAuth?.success) {
        setShowLoginModal(true);
        return;
      }

      const response = await fetch(`${API_BASE}/api/bookFlightSSR`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          ...reqBody,
        }),
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || "Booking with SSR failed");
      }

      const calculatedTotal = flight?.Fare?.total?.total
        ? Number(flight.Fare.total.total) + 300
        : data.data?.totalAmount || 0;

      const bookingId =
        data.data?.Status?.refID ||
        data.data?.Status?.bookingReference ||
        data.data?.bookingReference ||
        data.data?.refID ||
        statusDatas ||
        "N/A";

      // Send booking confirmation email
      const emailResult = await sendBookingConfirmationEmail({
        flightInfo: selectedFlightForPrice,
        passengerDetails: passengerData,
        contactInfo: { mobile: contactInfo.mobile, email: contactInfo.email },
        selectedSeats: selectedSeats,
        totalAmount: calculatedTotal,
        bookingReference: bookingId,
      });

      setBookingResult(data.data);
      setBookingSuccessData({
        ...data.data,
        emailSent: emailResult.success,
        emailMessage: emailResult.message,
      });
      setShowBookingSuccess(true);

      if (dataforWallet == "wallet") {
        const res = await axios.post(
          `${url}/api/wallet/deduct`,
          { amount },
          {
            withCredentials: true,
          }
        );
      }

      return data.data;
    } catch (error) {
      setBookingError(error.message);
      throw error;
    } finally {
      setIsBooking(false);
    }
  };

  // Regular Booking API (without SSR)
  const bookSelectedFlight = async (
    flight,
    passenger,
    searchPayload,
    dataforWallet,
    amount
  ) => {
    try {
      setIsBooking(true);
      setBookingError(null);
      setBookingResult(null);

      const clientId = generateClientID();
      const passengerData = generatePassengerDetails();

      const reqBody = {
        ...searchPayload,
        selected: flight,
        returnRefID: statusDatas,
        clientID: clientId,
        selectedSeats: selectedSeats,
        passenger: passengerData,
        mobile: contactInfo.mobile,
        email: contactInfo.email,
        flightID: flight?.Flights?.Onward[0]?.flightID,
        serType: formData.serType,
        tripType: tripType,
        // Add round trip specific data
        isRoundTrip: flight.isRoundTrip || false,
        onwardRefID: onwardRefID,
        onwardFlight: flight.onwardFlight || null,
        returnFlight: flight.returnFlight || null,
        totalAmount: flight.totalPrice || flight?.Fare?.total?.total,
        // returnRefId: returnRefId,
      };

      const response = await fetch(`${API_BASE}/api/checkAuth`, {
        credentials: "include",
      });
      const dataAuth = await response.json();

      if (!dataAuth?.success) {
        setShowLoginModal(true);
        return;
      }

      const res = await fetch(`${API_BASE}/api/bookFlight`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ ...reqBody }),
      });

      const data = await res.json();
      if (!res.ok || !data.success) {
        throw new Error(data.message || "Booking failed");
      }

      const calculatedTotal = flight?.Fare?.total?.total
        ? Number(flight.Fare.total.total) + 300
        : data.data?.totalAmount || 0;

      const bookingId =
        data.data?.Status?.refID ||
        data.data?.Status?.bookingReference ||
        data.data?.bookingReference ||
        data.data?.refID ||
        statusDatas ||
        "N/A";

      const emailResult = await sendBookingConfirmationEmail({
        flightInfo: flight,
        passengerDetails: passengerData,
        contactInfo: { mobile: contactInfo.mobile, email: contactInfo.email },
        selectedSeats: selectedSeats,
        totalAmount: calculatedTotal,
        bookingReference: bookingId,
      });

      setBookingResult(data.data);
      setBookingSuccessData({
        ...data.data,
        bookingReference: bookingId,
        totalAmount: calculatedTotal,
        userEmail: contactInfo.email,
        emailSent: emailResult.success,
        emailMessage: emailResult.message,
      });
      setShowBookingSuccess(true);
      if (dataforWallet == "wallet") {
        const res = await axios.post(
          `${url}/api/wallet/deduct`,
          { amount },
          {
            withCredentials: true,
          }
        );
      }

      return data.data;
    } catch (e) {
      setBookingError(e.message);
      throw e;
    } finally {
      setIsBooking(false);
    }
  };

  // Function to combine flight results for round trips
  const combineFlightResults = (onwardFlights, returnFlights) => {
    const combined = [];

    // Create all possible combinations
    onwardFlights.forEach((onwardFlight, onwardIndex) => {
      returnFlights.forEach((returnFlight, returnIndex) => {
        combined.push({
          id: `${onwardIndex}-${returnIndex}`,
          isRoundTrip: true,
          onwardFlight: onwardFlight,
          returnFlight: returnFlight,
          // Calculate total price
          totalPrice: (
            parseInt(onwardFlight.Fare?.total?.total || 0) +
            parseInt(returnFlight.Fare?.total?.total || 0)
          ).toString(),
          // Calculate total duration
          totalDuration:
            getTotalDurationMinutes(onwardFlight?.Flights?.Onward) +
            getTotalDurationMinutes(returnFlight?.Flights?.Onward),
        });
      });
    });

    // Sort by cheapest by default
    const sortedCombined = combined.sort(
      (a, b) => parseInt(a.totalPrice) - parseInt(b.totalPrice)
    );
    return sortedCombined;
  };

  // Sorting function
  const sortFlights = (flights, criteria) => {
    const sorted = [...flights];

    switch (criteria) {
      case "cheapest":
        return sorted.sort((a, b) => {
          const priceA = a.isRoundTrip
            ? parseInt(a.totalPrice)
            : parseInt(a.Fare?.total?.total || 0);
          const priceB = b.isRoundTrip
            ? parseInt(b.totalPrice)
            : parseInt(b.Fare?.total?.total || 0);
          return priceA - priceB;
        });

      case "fastest":
        return sorted.sort((a, b) => {
          const durationA = a.isRoundTrip
            ? a.totalDuration
            : getTotalDurationMinutes(a?.Flights?.Onward);
          const durationB = b.isRoundTrip
            ? b.totalDuration
            : getTotalDurationMinutes(b?.Flights?.Onward);
          return durationA - durationB;
        });

      case "special":
        // Sort by special deals or airline preference
        return sorted.sort((a, b) => {
          const airlineA = a.isRoundTrip
            ? a.onwardFlight?.Flights?.AirlineName
            : a.Flights?.AirlineName;
          const airlineB = b.isRoundTrip
            ? b.onwardFlight?.Flights?.AirlineName
            : b.Flights?.AirlineName;
          return airlineA?.localeCompare(airlineB) || 0;
        });

      default:
        return sorted;
    }
  };

  // Apply sorting when sortBy changes
  useEffect(() => {
    if (combinedResults.length > 0) {
      const sorted = sortFlights(combinedResults, sortBy);
      setCombinedResults(sorted);
    }
  }, [sortBy]);

  // Optimized handleSearch function - FIXED VERSION
  const handleSearch = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setSearchResults({ onward: [], return: [] });
    setCombinedResults([]);
    setShowResults(false);
    setDebugInfo("Starting search process...");

    try {
      if (!formData.from || !formData.to || !formData.departure) {
        throw new Error(
          "Please fill in all required fields (From, To, and Departure Date)"
        );
      }

      if (tripType == 1 && !formData.returnDate) {
        throw new Error("Please select a Return Date for Round Trip");
      }

      const totalNonInfant = (formData.adults || 0) + (formData.children || 0);
      if (formData.adults < 1 || formData.adults > 9) {
        throw new Error("Adults must be between 1 and 9");
      }
      if (totalNonInfant > 9) {
        throw new Error("Total of Adults + Children cannot exceed 9");
      }
      if (formData.infants > Math.min(4, formData.adults)) {
        throw new Error("Infants cannot be more than Adults and maximum 4");
      }

      const extractCodeFromDisplay = (displayValue) => {
        if (!displayValue) return null;
        const match = displayValue.match(/\(([A-Z]{3})\)/);
        return match ? match[1] : null;
      };

      const fromLocation = airports.find((airport) => {
        const displayFormats = [
          `${airport.name} (${airport.code})`,
          `${airport.name}, ${airport.country} (${airport.code})`,
          `${airport.city} (${airport.code})`,
          `${airport.city}, ${airport.country} (${airport.code})`,
        ];

        if (displayFormats.some((format) => format === formData.from)) {
          return true;
        }

        if (formData.from === airport.code) {
          return true;
        }

        const extractedCode = extractCodeFromDisplay(formData.from);
        if (extractedCode && extractedCode === airport.code) {
          return true;
        }

        return false;
      });

      const toLocation = airports.find((airport) => {
        const displayFormats = [
          `${airport.name} (${airport.code})`,
          `${airport.name}, ${airport.country} (${airport.code})`,
          `${airport.city} (${airport.code})`,
          `${airport.city}, ${airport.country} (${airport.code})`,
        ];

        if (displayFormats.some((format) => format === formData.to)) {
          return true;
        }

        if (formData.to === airport.code) {
          return true;
        }

        const extractedCode = extractCodeFromDisplay(formData.to);
        if (extractedCode && extractedCode === airport.code) {
          return true;
        }

        return false;
      });

      if (!fromLocation || !toLocation) {
        throw new Error(
          "Please select valid departure and arrival locations from the dropdown"
        );
      }

      const formatDate = (iso) => (iso ? iso.replaceAll("-", "") : "");

      // IMPORTANT: Always send the actual tripType to the API
      // For international flights, the API should handle round trips in one call
      const searchData = {
        tripType: tripType, // Send 0 for one-way, 1 for round trip
        serType: formData.serType,
        depCity: fromLocation.code,
        arrCity: toLocation.code,
        onDate: formatDate(formData.departure),
        reDate: tripType === 1 ? formatDate(formData.returnDate) : "",
        adt: formData.adults,
        chd: formData.children,
        inf: formData.infants,
        cabin: formData.cabin,
        fareType: formData.fareType,
      };

      setDebugInfo(`Sending search request: ${JSON.stringify(searchData)}`);
      setLastSearchPayload(searchData);

      // SINGLE API CALL FOR ALL CASES
      // The backend API should handle both domestic and international searches appropriately
      const searchResponse = await searchFlights(searchData);

      if (searchResponse && searchResponse.results) {
        setStatusRefdId(searchResponse?.Status?.refID || "");

        // Extract flights from searchResponse (V2 structure)
        const flights = searchResponse?.results || searchResponse?.flights || searchResponse?.data?.flights || searchResponse?.data?.Results || [];

        // V2: Handle different response structures based on service type
        if (formData.serType === 2) {
          // INTERNATIONAL FLIGHTS
          // V2: For international, check if round trip has both Onward and Return in single flight object
          if (tripType === 1) {
            // International round trip - V2 may return flights with both Onward and Return
            const roundTripFlights = flights.filter((f) => f.Flights?.Onward && f.Flights?.Return);
            const oneWayFlights = flights.filter((f) => !f.Flights?.Return);

            if (roundTripFlights.length > 0) {
              // V2: Flights with both onward and return
              setSearchResults({
                onward: roundTripFlights,
                return: [],
              });
              setCombinedResults(
                roundTripFlights.map((flight) => ({
                  ...flight,
                  isRoundTrip: true,
                  onwardFlight: { ...flight, Flights: { Onward: flight.Flights.Onward } },
                  returnFlight: { ...flight, Flights: { Onward: flight.Flights.Return } },
                }))
              );
            } else if (searchResponse.onward && searchResponse.return) {
              // Separate onward/return arrays
              setSearchResults({
                onward: searchResponse.onward,
                return: searchResponse.return,
              });
              const combined = combineFlightResults(searchResponse.onward, searchResponse.return);
              setCombinedResults(combined);
            } else {
              // Treat as one-way for now
              setSearchResults({ onward: flights, return: [] });
              setCombinedResults(
                flights.map((flight) => ({
                  ...flight,
                  isRoundTrip: false,
                  onwardFlight: flight,
                  returnFlight: null,
                }))
              );
            }
          } else {
            // International one-way
            setSearchResults({ onward: flights, return: [] });
            setCombinedResults(
              flights.map((flight) => ({
                ...flight,
                isRoundTrip: false,
                onwardFlight: flight,
                returnFlight: null,
              }))
            );
          }
        } else {
          // DOMESTIC FLIGHTS
          if (tripType === 1) {
            // Domestic round trip - need separate return search
            if (searchResponse.returnResults) {
              setSearchResults({
                onward: flights,
                return: searchResponse.returnResults,
              });
              const combined = combineFlightResults(flights, searchResponse.returnResults);
              setCombinedResults(combined);
            } else {
              // Make separate return search
              setDebugInfo("Domestic round trip - searching for return flights...");

              const returnSearchData = {
                tripType: 0,
                serType: formData.serType,
                depCity: toLocation.code,
                arrCity: fromLocation.code,
                onDate: formatDate(formData.returnDate),
                reDate: "",
                adt: formData.adults,
                chd: formData.children,
                inf: formData.infants,
                cabin: formData.cabin,
                fareType: formData.fareType,
              };

              const returnResults = await searchFlights(returnSearchData);
              const returnFlights = returnResults?.results || returnResults?.flights || [];

              if (returnFlights.length > 0) {
                setSearchResults({
                  onward: flights,
                  return: returnFlights,
                });
                const combined = combineFlightResults(flights, returnFlights);
                setCombinedResults(combined);
              } else {
                setCombinedResults(
                  flights.map((flight) => ({
                    ...flight,
                    isRoundTrip: false,
                    onwardFlight: flight,
                    returnFlight: null,
                  }))
                );
              }
            }
          } else {
            // Domestic one-way
            setSearchResults({ onward: flights, return: [] });
            setCombinedResults(
              flights.map((flight) => ({
                ...flight,
                isRoundTrip: false,
                onwardFlight: flight,
                returnFlight: null,
              }))
            );
          }
        }

        setShowResults(true);
        storeNextDayDate();
      } else {
        throw new Error("No flight results received from server");
      }
    } catch (error) {
      console.error("Search error:", error);
      setError(error.message);
      setDebugInfo(`Final error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleDropdown = (dropdown) => {
    setDropdowns((prev) => {
      const wasOpen = !!prev[dropdown];
      const closedAll = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});
      return {
        ...closedAll,
        [dropdown]: !wasOpen,
      };
    });
  };

  const selectOption = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setDropdowns((prev) => ({
      ...prev,
      [field]: false,
    }));
  };

  const swapLocations = () => {
    setFormData((prev) => ({
      ...prev,
      from: prev.to,
      to: prev.from,
    }));
  };

  const toggleFlightDetails = (flightIndex) => {
    setExpandedFlights((prev) => ({
      ...prev,
      [flightIndex]: !prev[flightIndex],
    }));
  };

  // Generate unique clientID

  const generateClientID = () => {
    return authdata?.token?._id;
  };

  // Derived auth state

  // Initialize passenger form data
  const initializePassengerData = useCallback(() => {
    const totalpassenger =
      formData.adults + formData.children + formData.infants;
    const initialData = [];

    for (let i = 0; i < totalpassenger; i++) {
      initialData[i] = {
        title: "Mr",
        fName: "",
        lName: "",
        gender: "M",
        dob: "",
        ppNo: "",
        ppIss: "",
        ppExp: "",
        ppNat: "IN",
        // V2: Add document_id and panNo fields
        document_id: "",
        panNo: "",
      };
    }

    setFormPassengerData(initialData);
  }, [formData.adults, formData.children, formData.infants]);

  // Initialize passenger data when form opens
  useEffect(() => {
    if (showPassengerForm) {
      initializePassengerData();
    }
  }, [showPassengerForm, initializePassengerData]);

  // Handle passenger form data changes
  const handlePassengerDataChange = (passengerIndex, field, value) => {
    setFormPassengerData((prev) => {
      const newData = [...prev];
      newData[passengerIndex] = {
        ...newData[passengerIndex],
        [field]: value,
      };
      return newData;
    });

    setValue(`passengers.${passengerIndex}.${field}`, value, {
      shouldValidate: false,
      shouldDirty: true,
    });
  };

  // Convert date from YYYY-MM-DD to DD-MM-YYYY format
  const formatDateForAPI = (dateString) => {
    if (!dateString) return "01-01-1990";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // V2: Generate passenger details from form data with document_id and PAN support
  const generatePassengerDetails = () => {
    const totalpassenger =
      formData.adults + formData.children + formData.infants;
    const passenger = [];

    if (totalpassenger === 0) {
      const defaultPassenger = {
        title: "Mr",
        fName: "Test",
        lName: "User",
        pType: "A",
        gender: "M",
        dob: "01-01-1990",
        mobile: contactInfo.mobile || "",
        email: contactInfo.email || "",
        // V2: Add document_id and panNo if available
        ...(formPassengerData[0]?.document_id && { document_id: formPassengerData[0].document_id }),
        ...(formPassengerData[0]?.panNo && { panNo: formPassengerData[0].panNo }),
      };

      if (formData.serType === 2) {
        defaultPassenger.ppNo = "";
        defaultPassenger.ppIss = "";
        defaultPassenger.ppExp = "";
        defaultPassenger.ppNat = "IN";
      }

      return [defaultPassenger];
    }

    for (let i = 0; i < totalpassenger; i++) {
      const passengerData = formPassengerData[i] || [];
      const passengerType =
        i < formData.adults
          ? "A"
          : i < formData.adults + formData.children
          ? "C"
          : "I";

      const passengerObj = {
        title: passengerData.title || "Mr",
        fName: passengerData.fName || "Test",
        lName: passengerData.lName || "User",
        pType: passengerType,
        gender: passengerData.gender || "M",
        dob: formatDateForAPI(passengerData.dob),
      };

      // V2: Add document_id for Student/Sr Citizen/Defence fares
      if (passengerData.document_id) {
        passengerObj.document_id = passengerData.document_id;
      }

      // V2: Add panNo only for first passenger (SOTO bookings)
      if (i === 0 && passengerData.panNo) {
        passengerObj.panNo = passengerData.panNo;
      }

      if (formData.serType === 2) {
        passengerObj.ppNo = passengerData.ppNo || "";
        passengerObj.ppIss = formatDateForAPI(passengerData.ppIss);
        passengerObj.ppExp = formatDateForAPI(passengerData.ppExp);
        passengerObj.ppNat = passengerData.ppNat || "IN";
      }

      passenger.push(passengerObj);
    }

    return passenger;
  };

  // Helper functions for flight data
  const formatApiDateTime = (str) => {
    if (!str || str.length < 12) return "N/A";
    const y = Number(str.slice(0, 4));
    const m = Number(str.slice(4, 6)) - 1;
    const d = Number(str.slice(6, 8));
    const hh = Number(str.slice(8, 10));
    const mm = Number(str.slice(10, 12));
    const dt = new Date(y, m, d, hh, mm);
    return dt.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const minutesToHm = (minsStr) => {
    const mins = Number(minsStr || 0);
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return `${h}h ${m}m`;
  };

  const getSegments = (leg) => {
    if (!leg) return [];
    const vals = Array.isArray(leg) ? leg : Object.values(leg);
    return vals.filter((s) => s && s.flightNo);
  };

  const getStopsText = (leg) => {
    const segs = getSegments(leg);
    const stops = Math.max(0, segs.length - 1);
    if (stops === 0) return "Non-stop";
    const vias = segs
      .slice(0, -1)
      .map((s) => s.arrCode)
      .join(", ");
    return `${stops} Stop${stops > 1 ? "s" : ""}${vias ? ` via ${vias}` : ""}`;
  };

  const getTotalDurationMinutes = (leg) => {
    if (!leg) return 0;
    if (leg.durTotal) return Number(leg.durTotal);
    const segs = getSegments(leg);
    return segs.reduce((sum, s) => sum + Number(s.duration || 0), 0);
  };

  // Send booking confirmation email
  const sendBookingConfirmationEmail = async (bookingData) => {
    try {
      const emailData = {
        to: bookingData.contactInfo?.email || "itzzzamaan001@gmail.com",
        subject: "Flight Booking Confirmation",
        bookingDetails: {
          flightInfo: bookingData.flightInfo || {},
          passengerDetails: bookingData.passengerDetails || [],
          contactInfo: bookingData.contactInfo || {},
          selectedSeats: bookingData.selectedSeats || {},
          totalAmount: bookingData.totalAmount || 0,
          bookingReference: bookingData.bookingReference || "N/A",
          bookingDate: new Date().toLocaleString(),
        },
      };

      await new Promise((resolve) => setTimeout(resolve, 1000));

      return {
        success: true,
        message: "Booking confirmation email sent successfully",
      };
    } catch (error) {
      console.error("Error sending booking confirmation email:", error);
      return { success: false, message: "Failed to send confirmation email" };
    }
  };

  // Set minimum date for departure as today
  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  // Set minimum return date as departure date
  const getMinReturnDate = () => {
    return formData.departure || getTodayDate();
  };

  const handleAuthCheck = async (fare) => {
    setSelectedFlightForPrice(fare);

    const response = await fetch(`${API_BASE}/api/checkAuth`, {
      credentials: "include",
    });
    const dataAuth = await response.json();
    if (!dataAuth?.success) {
      setShowLoginModal(true);
      return;
    }

    // V2: Check if fare requires document or PAN from price check response
    // These fields come from the price verification API response
    const priceCheckData = fare?.priceCheckData || {};
    const requiresDocument = priceCheckData?.doc_mandatory === 1 || fare?.doc_mandatory === 1;
    const requiresPAN = priceCheckData?.pan_mandatory === 1 || fare?.pan_mandatory === 1;
    const documentType = priceCheckData?.document_type || fare?.document_type || ""; // 1=Student, 2=Sr Citizen, 3=Defence

    // Store V2 requirements in fare object for use in passenger form
    fare.requiresDocument = requiresDocument;
    fare.requiresPAN = requiresPAN;
    fare.documentType = documentType === 1 ? "student" : documentType === 2 ? "senior" : documentType === 3 ? "defence" : "";

    setSelectedFare(fare);
    setShowPassengerForm(true);
  };

  // ✅ DOB validation helper
  const handleDobChange = (value, index, type) => {
    const dobDate = new Date(value);

    if (type === "infant") {
      if (dobDate < sixtyDaysAgo || dobDate > today) {
        alert("Infant DOB must be within the last 60 days");
        return;
      }
    }
    if (type === "child") {
      if (dobDate < twelveYearsAgo || dobDate > today) {
        alert("Child DOB must be within the last 12 years");
        return;
      }
    }

    setFormPassengerData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = {
        ...updatedData[index],
        dob: value,
      };
      return updatedData;
    });

    setValue(`passengers.${index}.dob`, value, {
      shouldValidate: false,
      shouldDirty: true,
    });
  };

  // Booking execution with SSR selection
  const handleBooking = async (data = "", amount) => {
    try {
      // Generate clientID
      const clientId = generateClientID();

      // Get flightID and refID from localStorage
      const storedFlightData = getFlightDataFromStorage();

      // Get the full status object from localStorage
      let statusData = null;
      try {
        const flightStatus = localStorage.getItem("flightStatus");
        if (flightStatus) {
          statusData = JSON.parse(flightStatus);
        }
      } catch (error) {
        console.error("Error parsing status from localStorage:", error);
      }

      const flightId =
        storedFlightData.flightID || selectedFlightForPrice.flightID;
      const refId = storedFlightData.refID || selectedFlightForPrice.refID;

      // Generate passenger details from form data
      const generatedpassenger = generatePassengerDetails();

      const bookingData = {
        passenger: generatedpassenger,
        mobile: contactInfo.mobile,
        email: contactInfo.email,
        status: statusData,
        selectedSeats: selectedSeats,
      };

      // Choose between SSR and regular booking
      if (
        selectedFlightForPrice?.ssrInfo?.baggageOption ||
        selectedFlightForPrice?.ssrInfo?.mealOption ||
        selectedFlightForPrice?.selectedOnwardFare?.baggageOptions ||
        selectedFlightForPrice?.selectedOnwardFare?.mealOptions ||
        selectedFlightForPrice?.selectedOnwardFare?.baggageOptions ||
        selectedFlightForPrice?.selectedOnwardFare?.mealOptions
      ) {
        await bookFlightWithSSR(
          selectedFlightForPrice,
          lastSearchPayload,
          passengerDetails,
          data,
          amount
        );
      } else {
        await bookSelectedFlight(
          selectedFlightForPrice,
          passengerDetails,
          lastSearchPayload || {},
          data,
          amount
        );
      }
    } catch (error) {
      console.error("Booking error", error);
    }
  };

  const isWalletActive = userWallet !== null;
  const hasSufficientWalletBalance =
    isWalletActive && userWallet >= totalPayableAmount;

  const handlePay = async (onSuccess) => {
    try {
      if (!selectedFlightForPrice) {
        alert("Please select a flight and fare option first.");
        setIsPaying(false);
        return;
      }
      if (!amount) {
        alert("Please set the amount first.");
        setIsPaying(false);
        return;
      }

      const { data } = await axios.post(
        `${API_BASE}/create-order`,
        {
          amount: amount,
        },
        { withCredentials: true }
      );

      if (!data?.order) {
        alert("Failed to create order");
        setIsPaying(false);
        return;
      }

      const options = {
        key: import.meta.env.VITE_KEYID,
        amount: data.order.amount,
        currency: "INR",
        name: "FTD Travel",
        description: "Flight Booking Payment",
        order_id: data.order.id,
        handler: function (response) {
          alert("Payment successful!");
          if (typeof onSuccess === "function") {
            onSuccess(response);
          }
        },
        prefill: {
          name: "YUSUF KHAN",
          email: "yusuf@example.com",
          contact: "9999999999",
        },
        notes: {
          address: "FTD Travel Office",
        },
        theme: {
          color: "#3399cc",
        },
      };

      if (!window.Razorpay) {
        alert("Payment system not available. Please try again later.");
        setIsPaying(false);
        return;
      }

      const razor = new window.Razorpay(options);
      razor.open();

      if (razor && typeof razor.on === "function") {
        try {
          razor.on("modal.closed", function () {
            setIsPaying(false);
          });
        } catch (err) {
          console.error(err);
        }
      }

      razor.on("payment.failed", function (response) {
        console.error("❌ Payment Failed:", response.error);
        alert("Payment failed. Please try again.");
        setIsPaying(false);
      });
    } catch (err) {
      console.error("Payment Error:", err);
      setIsPaying(false);
    }
  };

  // const handleWalletPayment = async () => {
  //   try {
  //     if (!isWalletActive) {
  //       toast.error(
  //         "Please go to your profile and click on Activate Wallet. Our team will contact you."
  //       );
  //       return;
  //     }

  //     if (!hasSufficientWalletBalance) {
  //       toast.error(
  //         "Insufficient wallet balance. Please go to your profile and send a request to admin."
  //       );
  //       return;
  //     }

  //     const res = await axios.post(
  //       `${API_BASE}/api/wallet/pay`,
  //       { amount: totalPayableAmount },
  //       { withCredentials: true }
  //     );

  //     if (!res.data.success) {
  //       toast.error(res.data.message || "Wallet payment failed");
  //       return;
  //     }

  //     await handleBooking("wallet", totalPayableAmount);

  //     toast.success("Payment successful using Wallet");
  //     setIsOpen(false);
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Wallet payment failed");
  //   }
  // };

  const handleWalletPayment = async () => {
    // ✅ Confirmation first
    const confirmed = window.confirm(
      `Are you sure you want to pay ₹${totalPayableAmount} from your wallet?`
    );

    if (!confirmed) return;

    try {
      setIsWalletProcessing(true); // 🔒 disable all payment buttons

      if (!isWalletActive) {
        window.alert.error(
          "Please go to your profile and click on Activate Wallet. Our team will contact you."
        );
        return;
      }

      if (!hasSufficientWalletBalance) {
        window.alert.error(
          "Insufficient wallet balance. Please go to your profile and send a request to admin."
        );
        return;
      }

      // 1️⃣ Deduct wallet amount (or reserve)
      const res = await axios.post(
        `${API_BASE}/api/wallet/pay`,
        { amount: totalPayableAmount },
        { withCredentials: true }
      );

      if (!res.data.success) {
        window.alert.error(res.data.message || "Wallet payment failed");
        return;
      }

      // 2️⃣ Book flight
      await handleBooking("wallet", totalPayableAmount);

      window.alert.success("Payment successful using Wallet");
      setIsOpen(false);
    } catch (err) {
      console.error(err);
      window.alert.error("Wallet payment failed");
    } finally {
      setIsWalletProcessing(false); // 🔓 re-enable buttons
    }
  };

  const initiateBooking = () => {
    if (isPaying) return;
    setIsPaying(true);
    handlePay(async (paymentResponse) => {
      try {
        await handleBooking();

        setIsPaying(false);
        setIsOpen(false);
      } catch (error) {
        console.error("Booking error:", error);
        setIsPaying(false);
      }
    });
  };

  // Store next day date in localStorage when flight search is successful
  const storeNextDayDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    localStorage.setItem("flightSearchUpdateDate", tomorrow.toISOString());
  };

  // Clear all localStorage and cookies, then store next day date
  const handleUpdateStorage = () => {
    localStorage.clear();
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    storeNextDayDate();
    setShowUpdateModal(false);
    window.alert.success("Storage updated successfully!", {
      position: "top-center",
      autoClose: 3000,
    });
  };

  // Handle feedback submission
  const handleFeedbackSubmit = async () => {
    if (rating === 0) {
      window.alert.error("Please provide a rating", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    setIsSubmittingFeedback(true);
    try {
      const response = await axios.post(
        `${API_BASE}/api/review/create`,
        {
          rating: String(rating),
          description: feedbackText || "",
        },
        { withCredentials: true }
      );

      if (response.data.success) {
        window.alert.success(response.data.message || "Thank you for your feedback!", {
          position: "top-center",
          autoClose: 3000,
        });
        setShowFeedbackModal(false);
        setShowPassengerForm(false);
        setShowPriceModal(false);
        setBookingSuccessData(null);
        setRating(0);
        setFeedbackText("");
      } else {
        window.alert.error(
          response.data.message ||
            "Failed to submit feedback. Please try again.",
          {
            position: "top-center",
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      console.error("Feedback submission error:", error);
      if (error.response?.status === 401) {
        window.alert.error("Please login to submit feedback", {
          position: "top-center",
          autoClose: 3000,
        });
      } else if (error.response?.data?.message) {
        window.alert.error(error.response.data.message, {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        window.alert.error("Failed to submit feedback. Please try again.", {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } finally {
      setIsSubmittingFeedback(false);
    }
  };

  // Fetch airports on component mount
  useEffect(() => {
    const fetchAirports = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/airport`, {
          credentials: "include",
        });
        const data = await response.json();
        if (data.success && data.data) {
          const mappedAirports = data.data.map((airport) => ({
            code: airport.airportcode || airport.code,
            name: airport.airportname || airport.name,
            city: airport.airportcity || airport.city,
            country: airport.airportcountry || airport.country,
            airport: airport.airportname || airport.name,
          }));
          setAirports(mappedAirports);
        }
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    };
    fetchAirports();
  }, []);

  return (
    <div>
      <div
        className="min-h-screen md:h-[80vh] pb-8 relative overflow-hidden"
        style={{
          backgroundImage: `url(${flighthome})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-blue-900/20 bg-opacity-20"></div>

        {/* Background Airplane */}
        <div className="absolute inset-0 overflow-hidden">
          <motion.div
            className="absolute md:top-13 top-11 right-10 w-96 h-96 opacity-80"
            initial={{ x: 100, y: -50, rotate: 15 }}
            animate={{ x: 0, y: 0, rotate: 0 }}
            transition={{ duration: 2, ease: "easeOut" }}
          >
            <FaPlane className="text-9xl text-black" />
          </motion.div>
        </div>
        <div
          onClick={handleRefresh}
          className="absolute bg-blue-500 rounded-lg transition-all duration-200 hover:bg-blue-600 top-4 right-4 z-20 cursor-pointer"
        >
          <button className="flex items-center gap-2 text-white px-4 py-2 cursor-pointer">
            <FiRefreshCw className="text-white text-lg" />
            Refresh
          </button>
        </div>

        {/* Main Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 md:py-14 pt-8">
          <div className="flex flex-col items-center">
            {/* Main Heading */}
            <motion.h1
              className="text-[42px] md:text-6xl font-bold text-white text-center md:mb-13 mb-15"
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >
              Ready to take off?
            </motion.h1>

            {/* Search Form */}
            <SearchForm
              formData={formData}
              setFormData={setFormData}
              tripType={tripType}
              setTripType={setTripType}
              airports={airports}
              airportsByServiceType={airportsByServiceType}
              filteredFromAirports={filteredFromAirports}
              setFilteredFromAirports={setFilteredFromAirports}
              filteredToAirports={filteredToAirports}
              setFilteredToAirports={setFilteredToAirports}
              dropdowns={dropdowns}
              setDropdowns={setDropdowns}
              isLoading={isLoading}
              handleSearch={handleSearch}
              handleFromInputChange={handleFromInputChange}
              handleToInputChange={handleToInputChange}
              toggleDropdown={toggleDropdown}
              selectOption={selectOption}
              swapLocations={swapLocations}
              handleInputChange={handleInputChange}
              getTodayDate={getTodayDate}
              getMinReturnDate={getMinReturnDate}
              travellersRef={travellersRef}
              fromRef={fromRef}
              toRef={toRef}
              serviceRef={serviceRef}
              fareRef={fareRef}
              isLoadingLocations={isLoadingLocations}
              isLoadingFromAirports={isLoadingFromAirports}
              isLoadingToAirports={isLoadingToAirports}
            />
          </div>
        </div>
      </div>

      {waiting && (
        <div
          id="waitingNotification"
          className="flex bg-blue-50 p-2 text-2xl justify-center items-center"
        >
          Please wait for some time because its take some time to fetch the
          flight details...
        </div>
      )}

      {/* Error Display */}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mx-4 mt-4 max-w-5xl mx-auto">
          <div className="flex items-center">
            <FaExclamationTriangle className="text-red-500 mr-3 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-red-700 font-semibold">Search Error</p>
              <p className="text-red-600 text-sm mt-1">{error}</p>
            </div>
            <button
              onClick={() => setError(null)}
              className="ml-4 text-red-500 hover:text-red-700 flex-shrink-0"
            >
              <FaTimes />
            </button>
          </div>
        </div>
      )}

      {/* Flight Results */}
      <FlightResults
        showResults={showResults}
        setShowResults={setShowResults}
        searchResults={searchResults}
        combinedResults={combinedResults}
        pagedResults={pagedResults}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        handleAuthCheck={handleAuthCheck}
        pageSize={pageSize}
        tripType={tripType}
        expandedFlights={expandedFlights}
        toggleFlightDetails={toggleFlightDetails}
        setSelectedFlightForPrice={setSelectedFlightForPrice}
        setShowPriceModal={setShowPriceModal}
        verifyFlightPrice={verifyFlightPrice}
        fetchSSROptions={fetchSSROptions}
        statusRefdId={statusRefdId}
        formatApiDateTime={formatApiDateTime}
        minutesToHm={minutesToHm}
        getSegments={getSegments}
        getStopsText={getStopsText}
        getTotalDurationMinutes={getTotalDurationMinutes}
        sortBy={sortBy}
        setSortBy={setSortBy}
        filterStops={filterStops}
        setFilterStops={setFilterStops}
        serType={formData.serType}
      />

      {/* Price Modal */}
      <PriceModal
        showPriceModal={showPriceModal}
        setShowPriceModal={setShowPriceModal}
        selectedFlightForPrice={selectedFlightForPrice}
        isLoadingPrices={isLoadingPrices}
        priceOptions={priceOptions}
        handleAuthCheck={handleAuthCheck}
      />

      {/* Passenger Form */}
      <PassengerForm
        showPassengerForm={showPassengerForm}
        setShowPassengerForm={setShowPassengerForm}
        selectedFare={selectedFare}
        formData={formData}
        formPassengerData={formPassengerData}
        setFormPassengerData={setFormPassengerData}
        contactInfo={contactInfo}
        setContactInfo={setContactInfo}
        showSeatSelection={showSeatSelection}
        setShowSeatSelection={setShowSeatSelection}
        availableSeats={availableSeats}
        setAvailableSeats={setAvailableSeats}
        selectedSeats={selectedSeats}
        setSelectedSeats={setSelectedSeats}
        isLoadingSeats={isLoadingSeats}
        selectedSsr={selectedSsr}
        setSelectedSsr={setSelectedSsr}
        isBooking={isBooking}
        handleSubmit={handleSubmit}
        register={register}
        errors={errors}
        handlePassengerDataChange={handlePassengerDataChange}
        handleDobChange={handleDobChange}
        fetchSeats={fetchSeats}
        selectedFlightForPrice={selectedFlightForPrice}
        statusRefdId={statusRefdId}
        setIsOpen={setIsOpen}
        handleBooking={handleBooking}
      />

      <PaymentModal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
          setIsPaying(false);
        }}
        onConfirm={initiateBooking}
        fareData={selectedFlightForPrice}
        isPaying={isPaying}
        setAmount={setAmount}
        serType={formData.serType}
        seatTotal={Object.values(selectedSeats).reduce(
          (sum, seat) => sum + parseInt(seat?.seatAmt || 0),
          0
        )}
        userWallet={userWallet}
        totalPayableAmount={totalPayableAmount}
        onWalletPay={handleWalletPayment}
        isWalletProcessing={isWalletProcessing} // ✅ NEW
      />

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        setCheckModelLogin={() => setCheckModelLogin(true)}
        setUser={() => setUser(true)}
        onLoginSuccess={() => {
          setShowLoginModal(false);
          if (pendingFareForAuth) {
            setSelectedFare(pendingFareForAuth);
            setShowPassengerForm(true);
            setPendingFareForAuth(null);
          }
        }}
      />

      {/* Booking Success Modal */}
      <BookingSuccessModal
        showBookingSuccess={showBookingSuccess}
        setShowBookingSuccess={setShowBookingSuccess}
        bookingSuccessData={bookingSuccessData}
        selectedFlightForPrice={selectedFlightForPrice}
        contactInfo={contactInfo}
        setShowFeedbackModal={setShowFeedbackModal}
      />

      {/* Feedback Modal */}
      <FeedbackModal
        showFeedbackModal={showFeedbackModal}
        setShowFeedbackModal={setShowFeedbackModal}
        setShowPassengerForm={setShowPassengerForm}
        setShowPriceModal={setShowPriceModal}
        setBookingSuccessData={setBookingSuccessData}
        rating={rating}
        setRating={setRating}
        feedbackText={setFeedbackText}
        setFeedbackText={setFeedbackText}
        isSubmittingFeedback={isSubmittingFeedback}
        handleFeedbackSubmit={handleFeedbackSubmit}
      />

      {/* Update Storage Modal */}
      <UpdateStorageModal
        showUpdateModal={showUpdateModal}
        setShowUpdateModal={setShowUpdateModal}
        handleUpdateStorage={handleUpdateStorage}
      />

      {/* Sections */}
      <Features />
      <SpecialOffer />
      {/* <Price /> */}
      <About />
      <Services />
      {/* <Testimonials /> */}
      <Faq />

      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
};

export default Homepage2;
